module.exports = __webpack_public_path__ + "static/media/bj.486ce259.svg";